import * as Yup from 'yup';

const ReferralSourceSchema = Yup.object().shape({
  referralSource: Yup.object().shape({
    label: Yup.string(),
    value: Yup.string(),
  }),
  customReferralSource: Yup.object().when('referralSource', (referralSource) => {
    return referralSource?.value === 'other'
      ? Yup.string().required('Please provide a response')
      : Yup.string();
  }),
});

export default ReferralSourceSchema;
